var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 8.75C8.86193 8.75 8.75 8.86193 8.75 9V22C8.75 22.4142 8.41421 22.75 8 22.75C7.58579 22.75 7.25 22.4142 7.25 22V9C7.25 8.03351 8.03351 7.25 9 7.25H16C16.9665 7.25 17.75 8.03352 17.75 9V22C17.75 22.4142 17.4142 22.75 17 22.75C16.5858 22.75 16.25 22.4142 16.25 22V9C16.25 8.86192 16.1381 8.75 16 8.75H9Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 12.002C10.75 11.5877 11.0858 11.252 11.5 11.252H13.5C13.9142 11.252 14.25 11.5877 14.25 12.002C14.25 12.4162 13.9142 12.752 13.5 12.752H11.5C11.0858 12.752 10.75 12.4162 10.75 12.002ZM10.75 15.0011C10.75 14.5868 11.0858 14.2511 11.5 14.2511H13.5C13.9142 14.2511 14.25 14.5868 14.25 15.0011C14.25 15.4153 13.9142 15.7511 13.5 15.7511H11.5C11.0858 15.7511 10.75 15.4153 10.75 15.0011ZM14.25 17.9995C14.2504 18.4137 13.9149 18.7498 13.5007 18.7502L11.5007 18.752C11.0865 18.7523 10.7504 18.4168 10.75 18.0026C10.7496 17.5884 11.0851 17.2523 11.4993 17.252L13.4993 17.2502C13.9135 17.2498 14.2496 17.5853 14.25 17.9995Z",
    fill: "#76B72A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12.7441C3.86197 12.7441 3.75 12.8561 3.75 12.9941V21.9941C3.75 22.4084 3.41421 22.7441 3 22.7441C2.58579 22.7441 2.25 22.4084 2.25 21.9941V12.9941C2.25 12.0278 3.03347 11.2441 4 11.2441H8C8.41421 11.2441 8.75 11.5799 8.75 11.9941C8.75 12.4084 8.41421 12.7441 8 12.7441H4Z",
    fill: "#76B72A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.75 21.9878C22.7502 22.4021 22.4147 22.738 22.0004 22.7383L2.00044 22.75C1.58623 22.7502 1.25024 22.4146 1.25 22.0004C1.24976 21.5862 1.58535 21.2502 1.99956 21.25L21.9996 21.2383C22.4138 21.238 22.7498 21.5736 22.75 21.9878Z",
    fill: "#76B72A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5749 1.38213C12.7783 1.24219 13.0375 1.21131 13.268 1.29954L21.268 4.36091C21.5583 4.47199 21.75 4.75058 21.75 5.06137V22C21.75 22.4142 21.4142 22.75 21 22.75C20.5858 22.75 20.25 22.4142 20.25 22V5.57741L13.75 3.09005V7.97007C13.75 8.38429 13.4142 8.72007 13 8.72007C12.5858 8.72007 12.25 8.38429 12.25 7.97007V2C12.25 1.75313 12.3715 1.52207 12.5749 1.38213Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCity);
export default __webpack_public_path__ + "static/media/ic-city.2c4e1822505a48a37b7812c071effd3f.svg";
export { ForwardRef as ReactComponent };